define('modules/products/index',['require','exports','module','./collection','./activation/model','./activation/view'],function(require, exports, module) {
    "use strict";

    module.exports = {
        Collection: require("./collection"),
        Models: {
            Activation: require("./activation/model")
        },
        Views: {
            Activation: require("./activation/view")
        }
    };
});

